<template>
  <div
    class="app-upload__tip"
    :class="type">
    <el-icon v-if="icon">
      <component :is="icon"/>
    </el-icon>
    {{ title }}
  </div>
</template>

<script setup lang="ts">
const { icon = '', type = 'success', title = '' } = defineProps<{
  icon?: string;
  type?: string;
  title?: string;
}>();
</script>

<style>
.app-upload__tip {
  @apply font-normal text-lg flex items-center gap-8 mb-8;

  &.success .el-icon {
    @apply text-old-green-90;
  }

  &.error {
    & .el-icon {
      @apply text-old-red-90;
    }
  }
}
</style>
